module.exports = __webpack_public_path__ + "static/media/TXL-BUSD.662d61dc.svg";